import React, { useContext } from 'react'
import { WorkModel } from '@Entities/work/work'
import WorkItemSimple from '@Components/WorkItemSimple'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'

interface WorkItemsSimpleTableProps {
    workModelList: WorkModel[]
    valid: boolean
    disableView?: boolean
}

const WorkItemsSimpleTable = (props: WorkItemsSimpleTableProps) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)
    const { workModelList, valid, disableView } = props

    return (
        <>
            {workModelList.map((work: WorkModel) => (
                <WorkItemSimple
                    key={work.id ?? work.localId}
                    data={work}
                    valid={valid}
                    disableView={disableView}
                    rightsHolderId={rightsholderStore.currentRightsholderId}
                />
            ))}
        </>
    )
}

export default WorkItemsSimpleTable
